/**
 * TanStack Query hooks for `gamification-engine-points-levels-badges-goal-tracker-ui`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	gamificationEnginePointsLevelsBadgesGoalTrackerUiQueryKeys,
	type CreateGamificationEnginePointsLevelsBadgesGoalTrackerUiBody,
	type ListGamificationEnginePointsLevelsBadgesGoalTrackerUiResponse,
	type GamificationEnginePointsLevelsBadgesGoalTrackerUiRow,
} from "./api";

export function useGamificationEnginePointsLevelsBadgesGoalTrackerUiList(): UseQueryResult<ListGamificationEnginePointsLevelsBadgesGoalTrackerUiResponse, Error> {
	return useQuery({
		queryKey: gamificationEnginePointsLevelsBadgesGoalTrackerUiQueryKeys.list(),
		queryFn: list,
	});
}

export function useGamificationEnginePointsLevelsBadgesGoalTrackerUiCreate(): UseMutationResult<GamificationEnginePointsLevelsBadgesGoalTrackerUiRow, Error, CreateGamificationEnginePointsLevelsBadgesGoalTrackerUiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: gamificationEnginePointsLevelsBadgesGoalTrackerUiQueryKeys.all });
		},
	});
}

export function useGamificationEnginePointsLevelsBadgesGoalTrackerUiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: gamificationEnginePointsLevelsBadgesGoalTrackerUiQueryKeys.all });
		},
	});
}
